module.exports = __webpack_public_path__ + "img/conso.886a8a29.webp";